import React from "react";
import { motion } from "framer-motion";

export default function FloatingShapes() {
  const shapes = [
    { c: "#FEF08A", s: 120, x: "8%",  y: "18%", d: 0  , r: "rounded-[40%]" },
    { c: "#A7F3D0", s: 90,  x: "82%", y: "28%", d: 1.4, r: "rounded-full" },
    { c: "#DDD6FE", s: 140, x: "70%", y: "70%", d: 0.6, r: "rounded-[60%_40%_50%_50%]" },
    { c: "#FECACA", s: 70,  x: "12%", y: "75%", d: 2.0, r: "rounded-[30%_70%_60%_40%]" },
    { c: "#FBCFE8", s: 56,  x: "45%", y: "10%", d: 0.9, r: "rounded-full" },
    { c: "#BAE6FD", s: 100, x: "50%", y: "85%", d: 1.7, r: "rounded-[55%_45%_50%_50%]" },
  ];
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 overflow-hidden z-0">
      {shapes.map((sh, i) => (
        <motion.div
          key={i}
          className={`absolute ${sh.r} mix-blend-multiply`}
          style={{
            background: sh.c, width: sh.s, height: sh.s,
            left: sh.x, top: sh.y, filter: "blur(0.2px)",
            opacity: 0.55,
          }}
          animate={{ y: [-14, 14, -14], rotate: [-6, 6, -6] }}
          transition={{ duration: 9 + sh.d * 2, repeat: Infinity, ease: "easeInOut", delay: sh.d }}
        />
      ))}
    </div>
  );
}
